import { IAgencyGridRow } from '@/Interfaces/Agency.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { Chip, List, ListItem, Popover, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React, { useCallback, useState } from 'react';

const AdvertiserChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 12,
  overflow: 'text-ellipsis',
  maxWidth: '160px',
}));

const AdvertisersCell = ({ value }: GridRenderCellParams<IAgencyGridRow>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [first, second, ...rest] = value || [];

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  if (!value.length) {
    return '-';
  }

  return (
    <div className='overflow-hidden flex gap-1'>
      {first && <AdvertiserChip variant='outlined' label={first?.label} />}
      {second && <AdvertiserChip variant='outlined' label={second?.label} />}
      {rest.length > 0 && (
        <>
          <AdvertiserChip variant='outlined' label={`+${rest.length}`} onClick={handleClick} clickable />
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <List disablePadding>
              {rest.map((advertiser: IControlOption, index: number) => (
                <ListItem key={index} style={{ pointerEvents: 'none', padding: '8px 16px' }}>
                  {advertiser.label}
                </ListItem>
              ))}
            </List>
          </Popover>
        </>
      )}
    </div>
  );
};

export default AdvertisersCell;
